import React from 'react';

const Programs = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Training Programs</h1>
      <p>Training program management coming soon...</p>
    </div>
  );
};

export default Programs;